import { useGetUserQuery } from "@/services";
import { Spin } from "antd";
import dayjs from "dayjs";
import { string } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const InlineUser = ({ userId }) => {
  const intl = useIntl();

  const [userInfo, setUserInfo] = useState({});

  const {
    data: user,
    isFetching,
    refetch: refetchUser,
  } = useGetUserQuery(userId);

  useEffect(() => {
    if (!user) return;

    const { displayName, surname, givenName, email, id } = user;

    const cacheData = {
      surname,
      givenName,
      email,
      id,
      displayName,
      cachedAt: new Date(),
    };
    setUserInfo(cacheData);
    localStorage.setItem(`user:${cacheData.id}`, JSON.stringify(cacheData));
  }, [user]);

  useEffect(() => {
    if (!userId) return;

    const existing = localStorage.getItem(`user:${userId}`);

    if (existing) {
      setUserInfo(JSON.parse(existing));

      if (dayjs(existing.cachedAt).add(1, "day") < dayjs()) {
        refetchUser();
      }
    } else {
      refetchUser();
    }
  }, [userId, setUserInfo, refetchUser]);

  if (isFetching) return <Spin size="small" />;

  const { displayName, surname, givenName } = userInfo;

  return (
    <span>
      {userInfo
        ? displayName || `${surname}, ${givenName}`
        : intl.formatMessage({ id: "general.unknownUser" })}
    </span>
  );
};

InlineUser.propTypes = {
  userId: string.isRequired,
};

export default InlineUser;
